export const content = {
  ausschreibungsprozess: 'Ausschreibungsprozess',
  manuellerAusschreibungsprozess: 'Manueller Ausschreibungsprozess',
  manualSuccess: 'Ausschreibungsprozess erfolgreich auf manuell gestellt',
  automaticSuccess: 'Ausschreibungsprozess erfolgreich auf automatisch gestellt',
  changeError: 'Änderung am Ausschreibungsprozess konnte nicht gespeichert werden',
};
